import React from 'react'
import './Project.css';
import ProjectCard from './ProjectCard';
import royalmac from '../../assets/images/Royal-Mac.webp'
import royalmacFMCCG from '../../assets/images/RoyalMac-FMCG.webp'
import movieList from '../../assets/images/Movie Listing.webp'
import saqibPortfolio from '../../assets/images/Saqib-Portfolio.webp'
import liveUserFIlter from '../../assets/images/Live-User-Filter.webp'
import dictionary from '../../assets/images/Dictionary.webp'
// import publicVoteSurvey from '../../assets/images/Public-Vote-Survey.webp'
import quiz from '../../assets/images/Quiz.webp'
import landingPage from '../../assets/images/Landing-Page.webp'
import graphicDesigner from '../../assets/images/graphic-designer.webp'

const Project = () => {

    const projectLists = [
        {
            "title" : "RoyalMac Pvt Ltd",
            "desc"  : "Royal Mac Pvt Ltd is an international company dealing with new venture business investment methods for growing business in large scale industries.", 
            'image' : royalmac,
            'technology' : "Html CSS Javascript Jquery PHP",
            "location" : "https://mohammed-saqib.github.io/RoyalMac-Commodity/",
        },
        {
            "title" : "RoyalMac International",
            "desc"  : "RoyalMac is one point FMCG availability solution all around the world. We have all Country Origin FMCG Products for you that you need.", 
            'image' : royalmacFMCCG,
            'technology' : "Html CSS Javascript Jquery PHP",
            "location" : "https://mohammed-saqib.github.io/RoyalMac-FMCG/",
        },
        {
            "title" : "Movie Listing",
            "desc"  : "This Applications Displays List Of movies and shows, the user can find any movie details or shows details by typing the name in the search bar.", 
            'image' : movieList,
            'technology' : "Html CSS Javascript ReactJs",
            "location" : "",
        },
        {
            "title" : "Saqib Portfolio",
            "desc"  : "This Application is My Portfolio which describes in details about my self..", 
            'image' : saqibPortfolio,
            'technology' : "Html CSS Javascript ReactJs",
            "location" : "https://mohammed-saqib-portfolio.netlify.app/",
        },
        {
            "title" : "Live User Filter",
            "desc"  : "This Applications Displays Live User Details with the help of API data.", 
            'image' : liveUserFIlter,
            'technology' : "Html CSS Javascript",
            "location" : "https://mohammed-saqib.github.io/Live-User-Filter/",
        },
        {
            "title" : "Dictionary Website",
            "desc"  : "This Application is Dictionary App where user can find the meaning for the words.", 
            'image' : dictionary,
            'technology' : "Html CSS Javascript",
            "location" : "https://dictionary-demo-website.netlify.app/",
        },
        {
            "title" : "Graphic Designer Portfolio",
            "desc"  : "This is graphic designer portfolio, where it describes the complete information.", 
            'image' : graphicDesigner,
            'technology' : "Html CSS Javascript",
            "location" : "https://mohammed-saqib.github.io/Graphic-Designer-Portfolio/",
        },
        {
            "title" : "Simple Quiz App",
            "desc"  : "This Application simply demonstrate the quiz app in which user can participate.", 
            'image' : quiz,
            'technology' : "Html CSS Javascript",
            "location" : "https://simply-quiz-application.netlify.app/",
        },
        {
            "title" : "Landing Page",
            "desc"  : "This Application simply demonstrate the Landing Page Of the Website.", 
            'image' : landingPage,
            'technology' : "Html CSS Javascript",
            "location" : "https://mohammed-saqib.github.io/RoyalMac-3D/",
        },
    ]
        
    return (
        <>
            <div className="sections">
                <div className="section-title"><span>03 .</span><h3>My Projects</h3></div>
                <div className="project-main-sec">
                    <h6 className="project-sec-title">Here are some of the projects with in my experience</h6>
                    <div className="project-crd-container">
                        {
                            projectLists.map((card,index)  => (
                            <ProjectCard projectDetail={card} key={index}/>
                            ))
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default Project;